// extracted by mini-css-extract-plugin
export default {"pagination":"procedure-tables-instructions_pagination__PYN5j"};